// extracted by mini-css-extract-plugin
export var disabled = "_1f-5";
export var error = "_1f-1";
export var fitContent = "_1f-6";
export var hasSuffix = "_1f-4";
export var iconWrapper = "_1f-b";
export var infoIconWrapper = "_1f-d _1f-b";
export var input = "_1f-a";
export var inputWrapper = "_1f-0";
export var large = "_1f-8";
export var leadingIconWrapper = "_1f-c _1f-b";
export var measureBox = "_1f-e";
export var medium = "_1f-7";
export var readonly = "_1f-2";
export var small = "_1f-3";
export var suffix = "_1f-9";